///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

const CardIcon = ({ height, fill, title = "Card", width }) => (
  <svg
    aria-labelledby="card-icon"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="card-icon">{title}</title>
    <defs>
      <path
        d="M2 8.667h5.333V2H2v6.667zM2 14h5.333v-4H2v4zm6.667 0H14V7.333H8.667V14zm0-12v4H14V2H8.667z"
        id="card-path"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <mask id="card-mask" fill="#fff">
        <use xlinkHref="#card-path" />
      </mask>
      <use fill="#000" xlinkHref="#card-icon" />
      <g mask="url(#card-mask)" fill={fill}>
        <path d="M0 0h16v16H0z" />
      </g>
    </g>
  </svg>
);

export default CardIcon;
